import cx from 'classnames';
import { CommentsDesign } from 'mk2/apps/blogs/constants';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import React from 'react';
import styles from './CommentPlaceholder.mscss';

interface OwnProps {
    design: CommentsDesign;
}

export const CommentPlaceholder = React.memo<OwnProps>(({
    design,
}) => (
    <div
        className={cx(
            styles.CommentPlaceholder,
            styles[`CommentPlaceholder--${CommentsDesign[design]}`],
        )}
    >
        <div
            className={cx(
                styles.CommentPlaceholder__avatar,
                styles[`CommentPlaceholder__avatar--${CommentsDesign[design]}`],
            )}
        >
            <LoadingPlaceholder width={32} height={32}/>
        </div>

        <div className={styles.CommentPlaceholder__layout}>
            <div
                className={cx(
                    styles.CommentPlaceholder__body,
                    styles[`CommentPlaceholder__body--${CommentsDesign[design]}`],
                )}
            >
                <LoadingPlaceholder width={90} />
                <LoadingPlaceholder width="95%" />
                <LoadingPlaceholder width="87%" />
                <LoadingPlaceholder width="41%" />
            </div>

            {design !== CommentsDesign.Legacy && (
                <div className={styles.CommentPlaceholder__footer}>
                    <LoadingPlaceholder width={135}/>
                    <LoadingPlaceholder width={95}/>
                </div>
            )}
        </div>
    </div>
));

CommentPlaceholder.displayName = 'CommentPlaceholder';
